import { SignIn, SignUp } from "@clerk/react";
import { LogoStacked, TaglineText } from "@/components/Brand";

const Shell = ({ children, title }) => (
  <div className="flex min-h-screen">
    <aside className="hidden w-[44%] flex-col justify-between bg-brand-pale p-12 lg:flex">
      <LogoStacked className="w-64" />
      <div>
        <h1 className="text-4xl font-black text-ink">{title}</h1>
        <p className="mt-3 text-lg text-ink" data-testid="auth-tagline"><TaglineText /></p>
      </div>
      <p className="text-sm text-muted2">Venue owners and LineGone admins sign in here. Customers never need an account.</p>
    </aside>
    <main className="flex flex-1 items-center justify-center px-4 py-10">{children}</main>
  </div>
);

export const SignInPage = () => (
  <Shell title="Welcome back to LineGone">
    <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
  </Shell>
);

export const SignUpPage = () => (
  <Shell title="Put your venue on LineGone">
    <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
  </Shell>
);
